var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-wrp"},[_c('img',{attrs:{"src":_vm.qrCodeImgSource,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }